<template>
	<button type="button" class="btn btn-sm btn-dark rounded-pill px-3 fw-bold" :class="[(selected) ? 'bg-gray-500' : null]" @click="select">{{ company.name }}</button>
</template>

<script>
	export default {
		props: {
			company: Object,
			selected: Boolean
		},
		setup(props, { emit }) {
			const select = () => emit('select', props.company.id);

			return { select };
		}
	}
</script>